import { formatFirmNameForEndpoints } from '@utils/generateAssetLinks';
import axios from 'axios';

export const fetchAllSlides = async () => {
    const { data } = await axios.get('/api/slides');
    return data;
};

export const fetchRebuttalSlides = async () => {
    const { data } = await axios.get('/api/slides/rebuttals');
    return data;
};

export const fetchSlide = async (slideId, leadId, firmName) => {
    const { data } = await axios.get(`/api/slides/${slideId}/${leadId}?firm=${formatFirmNameForEndpoints(firmName)}`);
    return data;
};

export const addSlide = async (body) => {
    return axios.post('/api/slides', body);
};

export const editSlide = async (data) => {
    const { id, ...body } = data;
    await axios.put(`/api/slides/${id}`, body);
};

export const sendSlidesAsPdf = async ({ keyword, selectedTerms, client }) => {
    const data = {
        client,
        url: `${window.location.origin}/pdf`,
        keyWordValidation: keyword,
        selectedTerms
    };

    return axios.post('/api/slides/html-to-pdf', data);
};

